import { Badge } from "@/components/ui/badge";
import { readableTextColor } from "@/lib/creator-tags/colors";
import { cx } from "@/utils/cx";

export const CohortBadge = ({ name, color, className }: { name: string; color: string; className?: string }) => (
  <Badge
    className={cx("w-fit max-w-full truncate", className)}
    style={{
      backgroundColor: `color-mix(in srgb, ${color} 15%, transparent)`,
      borderColor: `color-mix(in srgb, ${color} 35%, transparent)`,
      color: readableTextColor(color, 0.15),
    }}
    title={name}
  >
    {name}
  </Badge>
);
